<script setup lang="ts">
import {ref} from "vue";

import {Home, Image, Info, Menu, MessageCircle, Phone, Wrench, X} from "lucide-vue-next";

import "@/assets/styles/sidebar.css";

import {useRouter} from "vue-router";

const router = useRouter();

const isOpen = ref(false);

const toggleSidebar = () => {
  isOpen.value = !isOpen.value;
};

const goTo = (target: string) => {
  isOpen.value = false;

  // Wenn Onepager Section
  if (target.startsWith("#")) {
    router.push("/").then(() => {
      setTimeout(() => {
        document.querySelector(target)?.scrollIntoView({
          behavior: "smooth"
        });
      }, 50);
    });
    return;
  }

  // Normale Route
  router.push(target);
};

</script>

<template>

  <!-- TOPBAR -->
  <header class="topbar">

    <div class="brand">

      <img
          src="@/assets/images/logo.png"
          alt="Logo"
          class="brand-logo"
      />

      <div class="brand-text">
        <h2>TestGarten</h2>
        <span>Garten- & Landschaftsbau</span>
      </div>

    </div>

    <button class="menu-btn" @click="toggleSidebar">
      <Menu/>
    </button>

  </header>

  <!-- OVERLAY -->
  <div
      v-if="isOpen"
      class="sidebar-overlay"
      @click="toggleSidebar"
  />

  <!-- SIDEBAR -->
  <aside class="sidebar" :class="{ open: isOpen }">

    <div class="sidebar-header">

      <div class="brand">

        <img
            src="@/assets/images/logo.png"
            alt="Logo"
            class="brand-logo"
        />

        <div class="brand-text">
          <h2>TestGarten</h2>
          <span>Garten- & Landschaftsbau</span>
        </div>

      </div>

      <button class="close-btn" @click="toggleSidebar">
        <X/>
      </button>

    </div>

    <nav class="sidebar-links">

      <a @click="goTo('#home')">
        <Home/>
        Home
      </a>

      <a @click="goTo('#about')">
        <Info/>
        Über uns
      </a>

      <a @click="goTo('#services')">
        <Wrench/>
        Leistungen
      </a>

      <a @click="goTo('#review')">
        <MessageCircle/>
        Bewertungen
      </a>

      <a @click="goTo('#references')">
        <Image/>
        Referenzen
      </a>

      <a @click="goTo('#contact')">
        <Phone/>
        Kontakt
      </a>

      <a @click="goTo('/impressum')">
        Impressum
      </a>

      <a @click="goTo('/datenschutz')">
        Datenschutz
      </a>

    </nav>

  </aside>
</template>

<style scoped>
</style>